"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scopeRequestStringToArray = exports.scopeArrayToRequestString = void 0;
var constants_1 = require("./constants");
/**
 * Take an array of scope strings and form them in to a string
 * that is appropriate for the `scope` parameter in requests to commercetools.
 */
function scopeArrayToRequestString(scopes, projectKey) {
    if (!scopes) {
        return '';
    }
    return scopes.map(function (scope) { return scope + ":" + projectKey; }).join(' ');
}
exports.scopeArrayToRequestString = scopeArrayToRequestString;
/**
 * Take the scopes string returned by commercetools and parse it in to an
 * array of scope strings.
 */
function scopeRequestStringToArray(scopes) {
    if (!scopes) {
        return [];
    }
    return scopes
        .split(' ')
        .map(function (scope) { return scope.split(':')[0]; })
        .filter(function (scope) { return !constants_1.INVALID_SCOPES.includes(scope); });
}
exports.scopeRequestStringToArray = scopeRequestStringToArray;
//# sourceMappingURL=scopes.js.map